'use strict'

var Marionette = require('marionette')
var App = require('app')

// var FilterListItem = Marionette.View.extend({
//   template: require('./templates/filterOption.html'),
//   tagName: 'li',
//   events: {
//     'click': function (event) {
//       this.model.set('selected', !this.model.get('selected'))
//     }
//   },
//   modelEvents: {
//     'change': 'render'
//   }
// })
// var FilterList = Marionette.CollectionView.extend({
//   childView: FilterListItem
// })

// var FilterLayout = Marionette.View.extend({
//   template: require('./templates/filter.html'),
//   tagName: 'li',
//   regions: {
//     filterListRegion: '.filter-list__region'
//   },
//   onRender: function () {
//     // console.log(this.model.get('collection'))
//     var filterListView = new FilterList({collection: this.model.get('collection')})
//     this.filterListRegion.show(filterListView)
//   }
// })
// module.exports.FilterLayout = FilterLayout

var AccountView = Marionette.View.extend({
  template: require('./templates/account.html'),
  tagName: 'div',
  className: 'l-header__account-item',
  initialize: function () {
    console.log('account')
    console.log(this)
  },
  events: {
    'click':'onClick',
    'click .js-interface-close': 'onClose'
  },
  triggers: {
    'click .js-user-logout': 'logout',
    'click .js-user-settings': 'settings',
  },
  modelEvents: {
    'change': 'render'
  },
  onClose: function(event) {
    event.stopPropagation()
    this.el.querySelector('.js-account-interface').classList.remove('is-visible')
  },
  onClick: function(event) {
    event.stopPropagation()
    this.el.querySelector('.js-account-interface').classList.add('is-visible')
  }
})
module.exports.AccountView = AccountView

var NavigationItem = Marionette.View.extend({
  template: require('./templates/navigation-item.html'),
  tagName: 'div',
  className: function (data) {
    return 'l-header__navigation-item navigation-' + this.model.get('id')
  },
  events: {
    'click': function (event) {
      this.model.set('selected', !this.model.get('selected'))
    }
  },
  triggers: {
    'click': 'navigate'
  },
  modelEvents: {
    'change': 'render'
  }
})

var NavigationLayout = Marionette.CollectionView.extend({
  template: require('./templates/navigation.html'),
  className: 'navigation',
  childView: NavigationItem,
  childViewContainer: 'ul',
  filter: function (child, index, collection) {
    // determine if a user has access to a specific menu item
    return App.session.user.hasRole(child.get('role'))
  }
})

module.exports.NavigationLayout = NavigationLayout

var Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  className: 'header__inner',
  regions: {
    accountRegion: '.account__region',
    navigationRegion: '.navigation__region'
  }
})
module.exports.Layout = Layout



// WEBPACK FOOTER //
// ./js/modules/header/list/view.js